import { ReactComponent as SidebarIcon } from "../../assets/SVG/SidebarIcon.svg";
import { ReactComponent as MoonIcon } from "../../assets/SVG/MoonIcon.svg";
import { ReactComponent as SunIcon } from "../../assets/SVG/SunIcon.svg";
import { ReactComponent as HamburgerMenu } from "../../assets/SVG/HamburgerMenu.svg";
import { ReactComponent as DropdownArrow } from "../../assets/SVG/DropdownArrow.svg";
import { ReactComponent as BreadcrumbSeparator } from "../../assets/SVG/BreadcrumbSeparator.svg";
import { ReactComponent as DashboardIcon } from "../../assets/SVG/DashboardIcon.svg";
import { ReactComponent as UpDownArrowIcon } from "../../assets/SVG/UpDownArrowIcon.svg";
import { ReactComponent as NotificationIcon } from "../../assets/SVG/NotificationIcon.svg";
import { ReactComponent as FundsIcon } from "../../assets/SVG/FundsIcon.svg";
import { ReactComponent as CardLabelIcon } from "../../assets/SVG/CardLabelIcon.svg";
import { ReactComponent as AddIcon } from "../../assets/SVG/AddIcon.svg";
import { ReactComponent as SettingsIcon } from "../../assets/SVG/SettingsIcon.svg";
import { ReactComponent as SearchIcon } from "../../assets/SVG/SearchIcon.svg";
import { ReactComponent as FilterIcon } from "../../assets/SVG/FilterIcon.svg";
import { ReactComponent as OrderBookIcon } from "../../assets/SVG/OrderBookIcon.svg";
import { ReactComponent as BulkOrderIcon } from "../../assets/SVG/BulkOrderIcon.svg";
import { ReactComponent as ModificationBookIcon } from "../../assets/SVG/ModificationBookIcon.svg";
import { ReactComponent as DoubleLeftArrowIcon } from "../../assets/SVG/DoubleLeftArrowIcon.svg";
import { ReactComponent as LightbulbIcon } from "../../assets/SVG/LightbulbIcon.svg";
import { ReactComponent as RefreshIcon } from "../../assets/SVG/RefreshIcon.svg";
import { ReactComponent as DownloadIcon } from "../../assets/SVG/DownloadIcon.svg";
import { ReactComponent as ChevronDownIcon } from "../../assets/SVG/ChevronDownIcon.svg";
import { ReactComponent as HoldingBookIcon } from "../../assets/SVG/HoldingBookIcon.svg";
import { ReactComponent as PositionBookIcon } from "../../assets/SVG/PositionBookIcon.svg";
import { ReactComponent as PersonIcon } from "../../assets/SVG/PersonIcon.svg";
import { ReactComponent as LockIcon } from "../../assets/SVG/LockIcon.svg";
import { ReactComponent as PeopleIcon } from "../../assets/SVG/PeopleIcon.svg";
import { ReactComponent as DocumentIcon } from "../../assets/SVG/DocumentIcon.svg";
import { ReactComponent as BasketIcon } from "../../assets/SVG/BasketIcon.svg";
import { ReactComponent as ChartIcon } from "../../assets/SVG/ChartIcon.svg";
import { ReactComponent as TableSortIcon } from "../../assets/SVG/TableSortIcon.svg";
import { ReactComponent as StrategyProfilingIcon } from "../../assets/SVG/StrategyProfilingIcon.svg";
import { ReactComponent as ProfitArrowIcon } from "../../assets/SVG/ProfitArrowIcon.svg";
import { ReactComponent as LossArrowIcon } from "../../assets/SVG/LossArrowIcon.svg";
import { ReactComponent as MarketChangeArrowIcon } from "../../assets/SVG/MarketChangeArrowIcon.svg";
import { ReactComponent as SensorsIcon } from "../../assets/SVG/SensorsIcon.svg";
import { ReactComponent as WatchlistCardIcon } from "../../assets/SVG/WatchlistCardIcon.svg";
import {ReactComponent as RepeatIcon} from "../../assets/SVG/RepeatIcon.svg";
import {ReactComponent as RoundedCrossIcon} from "../../assets/SVG/RoundedCross.svg";
import {ReactComponent as VerifiedIcon} from "../../assets/SVG/VerifiedIcon.svg";
import { ReactComponent as BinIcon } from "../../assets/SVG/BinIcon.svg";
import { ReactComponent as SelectDropdownArrow } from "../../assets/SVG/SelectDropdownArrow.svg";
import { ReactComponent as ScriptDeleteIcon } from "../../assets/SVG/ScriptDeleteIcon.svg";
import { ReactComponent as ToggleOffIcon } from "../../assets/SVG/ToggleOffIcon.svg";
import { ReactComponent as ToggleOnIcon } from "../../assets/SVG/ToggleOnIcon.svg";
import { ReactComponent as EditPencilIcon } from "../../assets/SVG/EditPencilIcon.svg";
import { ReactComponent as DeleteTrashIcon } from "../../assets/SVG/DeleteTrashIcon.svg";
import { ReactComponent as ReloadIcon } from "../../assets/SVG/ReloadIcon.svg";
import { ReactComponent as ClientHealthIcon } from "../../assets/SVG/ClientHealthIcon.svg";
// Map of icon names to SVG components

const iconMap = {
  SidebarIcon,
  MoonIcon,
  SunIcon,
  HamburgerMenu,
  DropdownArrow,
  BreadcrumbSeparator,
  DashboardIcon,
  UpDownArrowIcon,
  NotificationIcon,
  FundsIcon,
  cardLabelIcon: CardLabelIcon,
  AddIcon,
  SettingsIcon,
  SearchIcon,
  FilterIcon,
  OrderBookIcon,
  BulkOrderIcon,
  ModificationBookIcon,
  DoubleLeftArrowIcon,
  LightbulbIcon,
  RefreshIcon,
  DownloadIcon,
  ChevronDownIcon,
  HoldingBookIcon,
  PositionBookIcon,
  PersonIcon,
  LockIcon,
  PeopleIcon,
  DocumentIcon,
  BasketIcon,
  ChartIcon,
  TableSortIcon,
  StrategyProfilingIcon,
  ProfitArrowIcon,
  LossArrowIcon,
  MarketChangeArrowIcon,
  SensorsIcon,
  WatchlistCardIcon,
  RepeatIcon,
  RoundedCrossIcon,
  VerifiedIcon,
  BinIcon,
  SelectDropdownArrow,
  ScriptDeleteIcon,
  ToggleOffIcon,
  ToggleOnIcon,
  EditPencilIcon,
  DeleteTrashIcon,
  ReloadIcon,
  ClientHealthIcon,
};

function GlobalIcon({ iconName, className, style, ...props }) {
  const IconComponent = iconMap[iconName];

  if (!IconComponent) {
    console.warn(`Icon "${iconName}" not found in iconMap. Available icons:`, Object.keys(iconMap));
    return null;
  }

  return <IconComponent className={className} style={style} {...props} />;
}

export default GlobalIcon;

